export default {
    "API_BASE_URL_AUTH":process.env.REACT_APP_API_BASE_URL_AUTH,
    "API_BASE_URL_CONTENT":process.env.REACT_APP_API_BASE_URL_CONTENT,
    "API_BASE_URL_SERVICE":process.env.REACT_APP_API_BASE_URL_SERVICE,
    "API_BASE_URL_FEEDBACK":process.env.REACT_APP_API_BASE_URL_FEEDBACK,
    "API_BASE_URL_IDENTITY":process.env.REACT_APP_API_BASE_URL_IDENTITY,
    "API_BASE_URL_ESG":process.env.REACT_APP_API_BASE_URL_ESG,
    
}
